import { useEffect } from 'react';

/** Read by DrawerSystem — drawer starts below fixed/absolute top chrome */
export const TOP_CHROME_HEIGHT_VAR = '--kuutio-admin-header-height';

/**
 * Publish the live height of a top header bar so the portal-mounted drawer
 * clears it (Chat / width / close row stays visible).
 *
 * @param {React.RefObject<HTMLElement|null>} ref
 */
export function usePublishTopChromeHeight(ref) {
  useEffect(() => {
    const el = ref?.current;
    if (!el) return undefined;

    const root = document.documentElement;
    const publish = () => {
      const h = Math.ceil(el.getBoundingClientRect().height);
      if (h > 0) root.style.setProperty(TOP_CHROME_HEIGHT_VAR, `${h}px`);
    };

    publish();
    const ro = new ResizeObserver(publish);
    ro.observe(el);
    window.addEventListener('resize', publish);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', publish);
      root.style.removeProperty(TOP_CHROME_HEIGHT_VAR);
    };
  }, [ref]);
}
